import { ITemplateDetailsMapper, TArrayFieldsMapper, TDefaultBooleanFields, TSettingOptions } from '../api/blueprints/blueprint-details.types';
import { ActionType, BlueprintFieldType, BlueprintType } from '../api/blueprints/blueprint.types';
import { PodiumAccessType } from '../api/podium.dao';
import BlueprintDetailsCustomConnectionGroups from '../components/_blueprints/blueprint-item-details-popover/blueprint-details-custom-connection-groups';
import BlueprintDetailsCustomConnections from '../components/_blueprints/blueprint-item-details-popover/blueprint-details-custom-connections';
import BlueprintDetailsCustomRoleConnections from '../components/_blueprints/blueprint-item-details-popover/blueprint-details-custom-role-connections';
import { ApprovalType } from '../components/_events/_manage-event/shared/connections-list/_create-zoom-webinar-modal/create-zoom-webinar-form-data.viewmodel';

export const FEATURE_PRESENTATION = 'Featured Presentation';
export const LINKS = 'Links';
export const MEETING_ACCESS = 'Meeting Access';
export const MEETING_NOTES = 'Meeting Notes';
export const REPLAY_PAGE = 'Replays Page';
export const MEETING_STATUS = 'Meeting Status';
export const TOPIC = 'Topic';
export const TRACK = 'Track';
export const TYPE = 'Type';
export const TIMEZONE = 'Timezone';
export const BUSINESS_LINE = 'Business Line';
export const REGION = 'Region';
export const EVENT_TYPE = 'Event Type';
export const ACCESS = 'Access';
export const DEFAULT_MEETING_DURATION = 'Default Meeting Duration';
export const CREATE_PASSPORT_SITE = 'Create Passport Site';
export const PASSPORT_JSON_FILE = 'Passport JSON file';
export const CREATE_SINGLE_MEETING = 'Automatically create single meeting';
export const MEETING_TEMPLATE = 'Meeting Template';
export const INTEGRATION_ENABLED = 'Integration';
export const EVENT_TYPES = 'Event Types';
export const SINGLE_MEETING_CUSTOM_PAGE = 'Create Single Meeting Custom Page';
export const PAGE_LABEL = 'Page Label';
export const PAGE_PATH = 'Page Path';
export const ATTENDEE_LINK = 'Attendee Link';
export const RECORD_ENABLED = 'Record Meeting';
export const MEETING_EXPIRATION = 'Meeting Expiration';
export const AUTO_REGISTRATION_ENABLED = 'Auto Registration';
export const GUIDELINES = 'Meeting Guidelines';
export const CONNECTIONS = 'Connections';
export const CONNECTION_GROUPS = 'Connection Groups';
export const ROLE_CONNECTIONS = 'Role Connections';
export const SHOW_LINK_ON_WELCOME_PAGE = 'Show link on Welcome page';
export const DESCRIPTION = 'Description';
export const ASSIGNED_AS_LANDING_PAGE = 'Assigned as Landing Page';
export const DISABLE_OTHER_PAGES = 'Disable all other pages';
export const SINGLE_MEETING_CONNECTIONS_TEMPLATE = 'Connection Template';
export const DEFAULT_MEETING_TEMPLATE = 'Default Meeting Template';
export const AUTO_SUBSCRIPTION_ENABLED = 'Auto Subscription';
export const PODIUM = 'Podium';
export const PRESENTER_VIEW = 'Presenter View';
export const ACCESS_TYPE = 'Access Type';
export const FEATURES = 'Features';

const eventActions: ActionType[] = [ActionType.PASSPORT_SITE, ActionType.SINGLE_MEETING];
const meetingActions: ActionType[] = [ActionType.SINGLE_MEETING_CUSTOM_PAGE];

export const actionsByType = {
    [BlueprintType.MEETING]: meetingActions,
    [BlueprintType.EVENT]: eventActions,
    [BlueprintType.CONNECTION]: [],
    [BlueprintType.ORDER]: [],
};

export const defaultBooleanBlueprintValues: TDefaultBooleanFields = {
    [BlueprintType.MEETING]: [
        {
            fieldName: 'replayEnabled',
            fieldValue: { name: 'replayEnabled', value: false, type: BlueprintFieldType.FORM_PREFILL },
        },
        {
            fieldName: 'featured',
            fieldValue: { name: 'featured', value: false, type: BlueprintFieldType.FORM_PREFILL },
        },
        {
            fieldName: 'recordEnabled',
            fieldValue: { name: 'recordEnabled', value: false, type: BlueprintFieldType.FORM_PREFILL },
        },
        {
            fieldName: 'expiryDays',
            fieldValue: { name: 'expiryDays', value: null, type: BlueprintFieldType.FORM_PREFILL },
        },
    ],
    [BlueprintType.EVENT]: [],
    [BlueprintType.CONNECTION]: [
        {
            fieldName: 'recordEnabled',
            fieldValue: { name: 'recordEnabled', value: false, type: BlueprintFieldType.FORM_PREFILL },
        },
        {
            fieldName: 'autoRegistrationEnabled',
            fieldValue: { name: 'autoRegistrationEnabled', value: false, type: BlueprintFieldType.FORM_PREFILL },
        },
        {
            fieldName: 'autoSubscriptionEnabled',
            fieldValue: { name: 'autoSubscriptionEnabled', value: false, type: BlueprintFieldType.FORM_PREFILL },
        },
        {
            fieldName: 'podiumLinkEnabled',
            fieldValue: { name: 'podiumLinkEnabled', value: false, type: BlueprintFieldType.FORM_PREFILL },
        },
        {
            fieldName: 'podiumPresenterViewEnabled',
            fieldValue: { name: 'podiumPresenterViewEnabled', value: false, type: BlueprintFieldType.FORM_PREFILL },
        },
        {
            fieldName: 'podiumAccessType',
            fieldValue: { name: 'podiumAccessType', value: PodiumAccessType.oeCentralSignIn, type: BlueprintFieldType.FORM_PREFILL },
        }
    ],
    [BlueprintType.ORDER]: [],
};

export const blueprintFieldsMapper: ITemplateDetailsMapper = {
    [BlueprintType.MEETING]: {
        featured: FEATURE_PRESENTATION,
        links: LINKS,
        meetingAccess: MEETING_ACCESS,
        notes: MEETING_NOTES,
        replayEnabled: REPLAY_PAGE,
        status: MEETING_STATUS,
        topic: TOPIC,
        track: TRACK,
        type: TYPE,
        connectionsBlueprintId: SINGLE_MEETING_CONNECTIONS_TEMPLATE,
        SINGLE_MEETING_CUSTOM_PAGE: SINGLE_MEETING_CUSTOM_PAGE,
        label: PAGE_LABEL,
        path: PAGE_PATH,
        pageLinkEnabled: SHOW_LINK_ON_WELCOME_PAGE,
        linkDescription: DESCRIPTION,
        landingPage: ASSIGNED_AS_LANDING_PAGE,
        disableOtherPages: DISABLE_OTHER_PAGES,
        recordEnabled: RECORD_ENABLED,
        expiryDays: MEETING_EXPIRATION,
    },
    [BlueprintType.EVENT]: {
        timeZone: TIMEZONE,
        businessLine: BUSINESS_LINE,
        defaultMeetingDuration: DEFAULT_MEETING_DURATION,
        eventAccess: ACCESS,
        region: REGION,
        type: EVENT_TYPE,
        PASSPORT_SITE: CREATE_PASSPORT_SITE,
        defaultMeetingBlueprintId: DEFAULT_MEETING_TEMPLATE,
        passportConfig: PASSPORT_JSON_FILE,
        SINGLE_MEETING: CREATE_SINGLE_MEETING,
        meetingBlueprintId: MEETING_TEMPLATE,
        integrationEnabled: INTEGRATION_ENABLED,
        attendeeLinkType: ATTENDEE_LINK,
        eventTypes: EVENT_TYPES,
        integrationMeetingBlueprintId: MEETING_TEMPLATE
    },
    [BlueprintType.CONNECTION]: {
        recordEnabled: RECORD_ENABLED,
        guidelines: GUIDELINES,
        autoRegistrationEnabled: AUTO_REGISTRATION_ENABLED,
        autoSubscriptionEnabled: AUTO_SUBSCRIPTION_ENABLED,
        connections: CONNECTIONS,
        connectionGroups: CONNECTION_GROUPS,
        roleConnections: ROLE_CONNECTIONS,
        podiumLinkEnabled: PODIUM,
        podiumPresenterViewEnabled: PRESENTER_VIEW,
        podiumAccessType: ACCESS_TYPE,
        features: FEATURES,
    },
    [BlueprintType.ORDER]: {},
};

export const arrayFieldsMapper: TArrayFieldsMapper = {
    [LINKS]: {
        label: 'Label',
        url: 'URL',
    }
};

export const settingOptions: TSettingOptions = {
    [BlueprintType.MEETING]: [
        {
            settingTitle: 'Meeting Settings',
            settingValues: [
                MEETING_STATUS,
                MEETING_ACCESS,
                RECORD_ENABLED,
                MEETING_EXPIRATION,
                REPLAY_PAGE,
                FEATURE_PRESENTATION,
                TYPE,
                TOPIC,
                TRACK,
                LINKS,
                MEETING_NOTES,
                SINGLE_MEETING_CONNECTIONS_TEMPLATE,
                SINGLE_MEETING_CUSTOM_PAGE,
                PAGE_LABEL,
                PAGE_PATH,
                SHOW_LINK_ON_WELCOME_PAGE,
                DESCRIPTION,
                ASSIGNED_AS_LANDING_PAGE,
                DISABLE_OTHER_PAGES
            ]
        }
    ],
    [BlueprintType.EVENT]: [
        {
            settingTitle: 'Event Settings',
            settingValues: [
                TIMEZONE,
                REGION,
                BUSINESS_LINE,
                EVENT_TYPE,
                ACCESS,
                DEFAULT_MEETING_DURATION,
                DEFAULT_MEETING_TEMPLATE,
                CREATE_PASSPORT_SITE,
                PASSPORT_JSON_FILE,
                CREATE_SINGLE_MEETING,
                MEETING_TEMPLATE,
                INTEGRATION_ENABLED,
                ATTENDEE_LINK,
                EVENT_TYPES
            ]
        },
    ],
    [BlueprintType.CONNECTION]: [
        {
            settingTitle: 'Connection Settings',
            settingValues: [
                GUIDELINES,
                AUTO_REGISTRATION_ENABLED,
                AUTO_SUBSCRIPTION_ENABLED,
            ]
        },
        {
            settingTitle: 'Connections',
            settingValues: [
                CONNECTIONS
            ],
            custom: true,
            component: BlueprintDetailsCustomConnections
        },
        {
            settingTitle: 'Connection Groups',
            settingValues: [
                CONNECTION_GROUPS
            ],
            custom: true,
            component: BlueprintDetailsCustomConnectionGroups
        },
        {
            settingTitle: 'Role Connections',
            settingValues: [
                ROLE_CONNECTIONS
            ],
            custom: true,
            component: BlueprintDetailsCustomRoleConnections
        },
        {
            settingTitle: 'Podium',
            settingValues: [
                PODIUM,
                PRESENTER_VIEW,
                ACCESS_TYPE,
                FEATURES
            ]
        },

    ],
    [BlueprintType.ORDER]: [],
};

export const approvalTypes = {
    [ApprovalType.AUTOMATICALLY]: 'Auto Approval',
    [ApprovalType.MANUALLY]: 'Manual Approval',
    [ApprovalType.NOT_REQUIRED]: 'Not Required'
};
